"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var Switch_1 = __importDefault(require("@material-ui/core/Switch"));
var utils_1 = __importDefault(require("@nexys/utils"));
var MySwitch = function (props) {
    var name = props.name, data = props.data, onChange = props.onChange, _a = props.disabled, disabled = _a === void 0 ? false : _a, id = props.id, color = props.color;
    var strName = name.toString();
    var value = Boolean(utils_1["default"].ds.get(strName, data));
    var _b = react_1.useState(value), checked = _b[0], setChecked = _b[1];
    react_1.useEffect(function () {
        setChecked(value);
    }, [data, value]);
    var handleChange = function () { return function () {
        setChecked(!checked);
        onChange({ name: strName, value: !checked });
    }; };
    return (react_1["default"].createElement(Switch_1["default"], { checked: checked, onChange: handleChange(), value: checked, inputProps: { 'aria-label': 'secondary checkbox' }, disabled: disabled, id: id ? id : strName, color: color }));
};
exports["default"] = MySwitch;
